import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/lapostebj.png'


const _hoisted_1 = { class: "mt-50" }
const _hoisted_2 = { class: "card border-0 rounded-0 bg-white authentication-card" }
const _hoisted_3 = { class: "card-body letter-spacing" }
const _hoisted_4 = { class: "form-group mb-10 mb-sm-15 mb-md-17" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = {
  ref: "submitButton",
  class: "text-decoration-none text-center default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success w-100",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-center mb-10" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "logo-icon",
              style: {"height":"100px"}
            })
          ], -1)),
          _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, " Connectez-vous à votre compte ! ", -1)),
          _createVNode(_component_Form, {
            ref: "loginForm",
            onSubmit: _ctx.onSubmitLogin,
            "validation-schema": _ctx.loginSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Email ", -1)),
                _createVNode(_component_Field, {
                  name: "email",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer votre email"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "email",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex align-items-center justify-content-between mb-10" }, [
                  _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Mot de passe ")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "password",
                  type: "password",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer votre mot de passe"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "password",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("button", _hoisted_6, " Connectez-vous maintenant ", 512)
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"color":"white !important","text-align":"center","margin-top":"15px  !important"} }, [
      _createElementVNode("a", {
        target: "_blank",
        href: "https://laposte.bj/mentions-legales/",
        style: {"text-decoration":"none","color":"white","margin":"0px 10px"}
      }, "Mentions légales"),
      _createElementVNode("a", {
        target: "_blank",
        href: "https://laposte.bj/donnees-personnelles/",
        style: {"text-decoration":"none","color":"white","margin":"0px 10px"}
      }, "Données personnelles"),
      _createElementVNode("a", {
        target: "_blank",
        href: "https://laposte.bj/cookies/",
        style: {"text-decoration":"none","color":"white","margin":"0px 10px"}
      }, "Cookies")
    ], -1))
  ], 64))
}